import React, { useState } from "react";
import EntryForm from "../components/EntryForm";

export default function AdjustmentEntry() {
  const [mode, setMode] = useState("adjustment");
  return (
    <div>
      <div className="flex items-center gap-2 mb-4">
        <button
          className={`px-4 py-2 text-sm font-semibold rounded-sm border ${mode === "adjustment" ? "bg-black text-white border-black" : "bg-white text-black border-gray-300"}`}
          onClick={() => setMode("adjustment")}
          data-testid="tab-adjustment"
        >Adjustment</button>
        <button
          className={`px-4 py-2 text-sm font-semibold rounded-sm border ${mode === "defective" ? "bg-black text-white border-black" : "bg-white text-black border-gray-300"}`}
          onClick={() => setMode("defective")}
          data-testid="tab-defective"
        >Defective</button>
      </div>
      <p className="small-label text-gray-500 mb-4">
        {mode === "adjustment"
          ? "Pick Add (+) or Reduce (−) per row and enter positive qty. Used for correcting physical count."
          : "Remove defective cylinders from stock. Enter positive qty to remove."}
      </p>
      <EntryForm type={mode} />
    </div>
  );
}
